import React from "react";
import { motion } from "framer-motion";
import {
  School, Sparkles, Home, FileCheck, Languages, Briefcase, LifeBuoy,
} from "lucide-react";

const items = [
  { icon: School, label: "Affordable public universities" },
  { icon: Sparkles, label: "Personalized university matching" },
  { icon: Home, label: "Housing assistance" },
  { icon: FileCheck, label: "Visa guidance" },
  { icon: Languages, label: "English-taught programs" },
  { icon: Briefcase, label: "Part-time job resources" },
  { icon: LifeBuoy, label: "Ongoing support until arrival" },
];

export default function TrustIndicators() {
  return (
    <section className="bg-white border-b border-[#0d1b3e]/10 py-8 md:py-10" data-testid="trust-indicators">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-7 gap-4 md:gap-6">
          {items.map(({ icon: Icon, label }, i) => (
            <motion.div
              key={label}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              className="flex items-start gap-3"
              data-testid={`trust-indicator-${i}`}
            >
              <div className="w-9 h-9 shrink-0 bg-[#f5f1e8] text-[#b8892b] flex items-center justify-center border border-[#b8892b]/30">
                <Icon size={16} />
              </div>
              <div className="text-[11px] uppercase tracking-[0.14em] font-semibold text-[#0d1b3e] leading-snug pt-1">
                {label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
